import { render, staticRenderFns } from "./IconEmail.vue?vue&type=template&id=1c2db239&"
import script from "./IconEmail.vue?vue&type=script&lang=ts&"
export * from "./IconEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports